export default {
  getLoanStatusDescription(loanStatus) {
    const loanStatusToCheck = loanStatus ? loanStatus.toString().toUpperCase() : "";
    const loanStatusDescription = loanStatusToCheck ? LoanStatusDescription[loanStatusToCheck] : {};
    return loanStatusDescription
      ? loanStatusDescription
      : { defaultStatusMessage: loanStatus, onboardingStatusMessage: loanStatus };
  }
};

export const LoanStatus = {
  ACTIVE: "Active",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  SUBMITTED_TO_FUND: "Submitted to Fund",
  SUBMITTED_TO_FUND_UNDERSCORE_UPPERCASE: "SUBMITTED_TO_FUND",
  SUBMITTED_AND_PENDING_APPROVAL: "Submitted and Pending Approval",
  SUBMITTED_AND_PENDING_APPROVAL_UNDERSCORE_UPPERCASE: "SUBMITTED_AND_PENDING_APPROVAL",
  WITHDRAWN_BY_APPLICANT: "Withdrawn by applicant",
  WITHDRAWN_BY_APPLICANT_UNDERSCORE_UPPERCASE: "WITHDRAWN_BY_APPLICANT",
  WITHDRAWN_BY_CLIENT: "Withdrawn by client",
  WITHDRAWN_BY_CLIENT_UNDERSCORE_UPPERCASE: "WITHDRAWN_BY_CLIENT",
  PENDING: "Pending",
  ABANDONED: "ABANDONED",
};

export const LoanStatusDescription = {
  ACTIVE: {
    defaultStatusMessage: "Active",
    onboardingStatusMessage: "Completed"
  },
  APPROVED: {
    defaultStatusMessage: "Approved",
    onboardingStatusMessage: "Under Process"
  },
  REJECTED: {
    defaultStatusMessage: "Rejected",
    onboardingStatusMessage: "Rejected"
  },
  "WITHDRAWN BY APPLICANT": {
    defaultStatusMessage: "Withdrawn by Applicant",
    onboardingStatusMessage: "Withdrawn by Applicant"
  },
  "WITHDRAWN_BY_APPLICANT": {
    defaultStatusMessage: "Withdrawn by Applicant",
    onboardingStatusMessage: "Withdrawn by Applicant"
  },
  "WITHDRAWN BY CLIENT": {
    defaultStatusMessage: "Withdrawn by Applicant",
    onboardingStatusMessage: "Withdrawn by Applicant"
  },
  "WITHDRAWN_BY_CLIENT": {
    defaultStatusMessage: "Withdrawn by Applicant",
    onboardingStatusMessage: "Withdrawn by Applicant"
  },
  "SUBMITTED TO FUND": {
    defaultStatusMessage: "Submitted for Approval",
    onboardingStatusMessage: "Under Process"
  },
  "SUBMITTED_TO_FUND": {
    defaultStatusMessage: "Submitted for Approval",
    onboardingStatusMessage: "Under Process"
  },
  "SUBMITTED AND PENDING APPROVAL": {
    defaultStatusMessage: "Application in Progress",
    onboardingStatusMessage: "Under Process"
  },
  "SUBMITTED_AND_PENDING_APPROVAL": {
    defaultStatusMessage: "Application in Progress",
    onboardingStatusMessage: "Under Process"
  },
  "PENDING": {
    defaultStatusMessage: "Pending",
    onboardingStatusMessage: "Pending"
  }
};
